import { compose, withStateHandlers, withProps } from 'recompose';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { constants as orderConstants } from 'utils/order';

import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';

import {
  actions as orderActions,
  selectors as orderSelector,
} from 'state/order';

import TypeOfOrderSelector from 'components/form/TypeOfOrderSelector/component';

const enhance = compose(
  withTranslation('TypeOfOrderSelector'),
  connect(
    (state) => ({
      typeOfOrder: orderSelector.getTypeOfOrder(state),
    }),
    {
      changeType: orderActions.setTypeOrder,
      resetType: orderActions.setRecurring,
      sendEvent: analyticsActions.sendEvent,
      disableEconomyMode: orderActions.disableEconomyMode,
    }
  ),
  withStateHandlers(
    ({ value }) => ({
      value,
    }),
    {
      handleChangeType:
        (_, { sendEvent, changeType, resetType, disableEconomyMode }) =>
        (__, { value }) => {
          sendEvent(analyticsEvents.form.orderTypeChanged({ type: value }));
          resetType({ isRecurring: false });
          changeType({ type: value });
          disableEconomyMode();
        },
    }
  ),
  withProps(({ t }) => ({
    options: [
      { value: orderConstants.DIRECT_ORDER, label: t('DIRECT_ORDER') },
      { value: orderConstants.DISTRIBUTION, label: t('DISTRIBUTION') },
      { value: orderConstants.COLLECTION, label: t('COLLECTION') },
      {
        value: orderConstants.DIRECT_ORDER_RECURRING,
        label: t('DIRECT_ORDER_RECURRING'),
      },
    ],
  }))
);

export default enhance(TypeOfOrderSelector);
